<div class="display-flex flex-column h-100 empty-dashboard-container">
  <div class="display-flex align-items-end grid-gap-16">
    <h3>Hello {{ userData?.firstName || '' }} {{ userData?.lastName || '' }}!</h3>
    <span class="body text-color dark">Here you will see your tasks</span>
  </div>
  <div class="image-container">
    <img width="284" height="284" src="assets/empty-dashboard.png" alt="" />
    <div class="image-description">No data to display.</div>
  </div>
</div>
